import scroll from "@/helpers/scroll";

export default {
    computed: {
        getUrlBrand() {
            return this.$route.params && this.$route.params.brand;
        },
        getUrlModel() {
            return this.$route.params && this.$route.params.model;
        },
        issetUserFriendlyParams() {
            return (this.getUrlBrand || this.getUrlModel) ? true : false;
        },
        showContentIosApp() {
            if (this.$device.ios) {
                if (this.showMenu) {
                    scroll.to(0);
                    this.showMenuPosition = scroll.offsetTopPage();
                    return false;
                } else {
                    if(this.showMenuPosition){
                        scroll.to(this.showMenuPosition);
                    }
                }
            }
            return true;
        }
    },
    methods: {
        getUrlName(str) {
            if (!str) {
                return false
            }
            return str
                .toString()
                .toLowerCase()
                .split('í').join('i')
                .split('ë').join('e')
                .split('é').join('e')
                .split('á').join('a')
                .split('æ').join('a')
                .split('ó').join('o')
                .split('ú').join('u')
                .split(' ').join('-')
                .split('&').join('and');

                /*return str
                .toString()
                .toLowerCase()
                .replaceAll("í", "i")
                .replaceAll("ë", "e")
                .replaceAll("é", "e")
                .replaceAll("á", "a")
                .replaceAll("æ", "a")
                .replaceAll("ó", "o")
                .replaceAll("ú", "u")
                .replaceAll(" ", "-");*/
        }
    }
}